import * as Constants from '../constants/ip-whitelist';

const initialState = {
  activeIpWhitelist: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_IP_WHITELIST_SUCCESS:
      return {
        ...state,
        activeIpWhitelist: action.payload,
      };
    case Constants.SET_IP_WHITELIST:
      return {
        ...state,
        activeIpWhitelist: action.payload,
      };
    default:
      return state;
  }
};
